export default __webpack_public_path__ + "static/media/menu-motor.71436a66.svg";